import { useState } from 'react';
import { truncateRichContent } from '@wix/ricos';
export function useTruncateRicosContent(content, maxShownParagraphs) {
  const [isTruncated, setIsTruncated] = useState(true);
  function toggleTruncate() {
    setIsTruncated(prevState => !prevState);
  }
  if (!maxShownParagraphs) {
    return {
      displayedContent: content,
      isTruncated: false,
      toggleTruncate
    };
  }
  const displayedContent = isTruncated ? truncateRichContent(content, {
    nodeCount: maxShownParagraphs
  }) : content;
  return {
    displayedContent,
    isTruncated,
    toggleTruncate
  };
}
//# sourceMappingURL=use-truncate-ricos-content.js.map